"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    box-sizing: border-box;\n    position: absolute;\n    opacity: 0;\n    width: 22px;\n    height: 22px;\n    cursor: pointer;\n    color: inherit;\n    font: inherit;\n    margin: 2px 0;\n    line-height: normal;\n    padding: 0;\n\n    ::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n    }\n\n    :-ms-input-placeholder {\n        color: #706e6b;\n        font-weight: 400;\n        font-size: 0.8125rem;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledStartInput = _styledComponents["default"].input(_templateObject());

var _default = StyledStartInput;
exports["default"] = _default;